var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-view"},[_c('tree-view-item',_vm._b({ref:"treeView",attrs:{"data":_vm.data[0],"collapsed":true,"depth":0,"numbering":_vm.getNumbering(),"priority":_vm.priority == 'max',"defaultValue":_vm.defaultValue,"titles":_vm.titles},on:{"updated":function($event){_vm.$emit('updated')}}},'tree-view-item',{ flat: _vm.flat, focus: _vm.focus, tips: _vm.tips },false))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b978e592","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/TreeView.vue
// module id = OUzs
// module chunks = 70